var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[(_vm.tableauId !== null)?_c('tableau-embedded',{attrs:{"tableauId":_vm.tableauId,"isCorpTableau":"true"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }